import { render, staticRenderFns } from "./propertyCompanyManageList.vue?vue&type=template&id=9a60dd46&scoped=true"
import script from "./propertyCompanyManageList.vue?vue&type=script&lang=js"
export * from "./propertyCompanyManageList.vue?vue&type=script&lang=js"
import style0 from "./propertyCompanyManageList.vue?vue&type=style&index=0&id=9a60dd46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a60dd46",
  null
  
)

export default component.exports